import React from "react"
import PropTypes from "prop-types"

const IconWithText = ({
  icon,
  text,
  textClassName,
  iconClassName,
  containerClassName,
}) => (
  <div role="listitem" className={`flex flex-col ${containerClassName}`}>
    <img className={iconClassName} src={icon} alt={text} />
    <small className={`text-dblue font-inter ${textClassName}`}>{text}</small>
  </div>
)

IconWithText.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.string,
  textClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  containerClassName: PropTypes.string,
}

IconWithText.defaultProps = {
  iconClassName: "h-16 w-16 xl:h-25 xl:w-25",
  textClassName: "text-16 xl:text-24 leading-140% font-normal",
  containerClassName: "gap-2 xl:gap-5 items-center justify-start text-center",
}

export default IconWithText
